/*
 * @Author: Liangli
 * @Date: 2021-12-15 13:53:21
 * @Last Modified by: Liangli
 * @Last Modified time: 2021-12-28 14:09:07
 * 仪表盘
 */
import _ from 'lodash'
import React, { Component } from 'react'

import CommonlyChart from '../charts'

const colors = {
  0: ['#FF4040', '#FB9639', '#45D852', '#FB9639', '#FF4040'],
  1: ['#45D852', '#FB9639', '#FF4040'],
}

class Gauge extends Component {


  constructor(props) {
    super(props)
    this.state = {
      multiple: 100,
    }
  }
  componentWillUnmount() {
  }
  UNSAFE_componentWillReceiveProps(nextP) {
    const { data, title } = nextP;
    if (data && !_.isEqual(data, this.props.data) || title !== this.props.title) {
      this.init(data, title)
    }
  }

  componentDidMount() {
    const { data, title } = this.props;
    if (data) {
      this.init(data, title)
    }
  }
  //判断值所属的区间
  valueTypeName = (value, data, type) => {
    const { multiple } = this.state;
    const _value = value * multiple;
    const arr = [{ value: _value }];
    let name = '';
    switch (type) {
      case 0:
        name = '正常'
        break;
      case 1:
        name = '关注'
        break;
      case 2:
        name = '危险'
        break;
    }
    arr[0].name = name;
    return arr
  }
  setAxisLabel = (type, formData, value) => {
    let str = '';
    switch (type) {
      case 0:
        if (value === Math.round(formData[0]) || value === Math.round(formData[4])) {
          str = '危险'
        }
        else if (value === Math.round(formData[1]) || value === Math.round(formData[3])) {
          str = '关注'
        }
        else if (value === Math.round(formData[2])) {
          str = '正常'
        }
        break;
      case 1:
        if (value === Math.round(formData[0])) {
          str = '正常'
        }
        else if (value === Math.round(formData[1])) {
          str = '关注'
        }
        else if (value === Math.round(formData[2])) {
          str = '危险'
        }
        break;
    }
    return str;
  }
  //粗略处理数据
  dealData = (data) => {
    let _data = {};
    switch (data.section.length) {
      case 4:
        _data.type = 0;
        break;
      case 2:
        _data.type = 1;
        break;
    }
    _data.value = data.value && data.value.toFixed(2)
    _data.data = [];
    data.section && data.section.map((item, index) => {
      _data.data.push(Number(item.beginNum));
    })
    _data.data.push(Number(data.section[data.section.length - 1].endNum));
    return _data;
  }
  init = (data, title) => {
    const { multiple } = this.state;
    const DATA = this.dealData(data);
    const formData = this.formatData(DATA.data);
    const graData = this.allGradient(formData, DATA.type);
    const seriesData = this.valueTypeName(DATA.value, formData, data.type);
    const value_show = data.value_show == null ? '--' : data.value_show;
    const option = {
      tooltip: {
        formatter: function (params) {
          return `${params.data.name}:${params.data.value / multiple}`
        }
      },
      grid: {
        // left: '50%',
      },
      series: [
        {
          name: '',
          type: 'gauge',
          startAngle: 210,
          endAngle: -30,
          radius: '80%',
          data: seriesData,
          min: formData[0],
          max: formData[formData.length - 1],
          splitNumber: formData[formData.length - 1],
          axisLine: {
            lineStyle: {
              color: graData,
              width: 10,
            }
          },
          splitLine: {
            show: false,
          },
          // splitLine: {
          //   length: 2,
          //   lineStyle: {
          //     color: '#fff',
          //     width: 1
          //   }
          // },
          axisTick: {
            show: false,
          },
          markLine: {
            // show: false,
          },
          axisLabel: {
            show: false,
            distance: -60,
            color: '#AEAEAE',
            fontSize: 12,
            formatter: (value) => {
              return this.setAxisLabel(DATA.type, formData, value)
            }
          },
          itemStyle: {
            color: '#4C5C70'
          },
          markArea: {
            label: {
              show: true,
              position: [100, 100],
            }
          },
          pointer: {
            width: 1,
            itemStyle: {
              color: '#fff'
            }
          },
          anchor: {
            show: true,
            showAbove: true,
            size: 4,
            itemStyle: {
              // borderWidth: 2,
              color: '#fff'
            }
          },
          title: {
            color: '#fff',
            offsetCenter: [0, '50%'],
            fontSize: 12,
          },
          detail: {               // 仪表盘详情，用于显示数据。
            show: true,             // 是否显示详情,默认 true。
            offsetCenter: [0, "94%"],// 相对于仪表盘中心的偏移位置，数组第一项是水平方向的偏移，第二项是垂直方向的偏移。可以是绝对的数值，也可以是相对于仪表盘半径的百分比。
            color: "#fff",          // 文字的颜色,默认 auto。
            fontSize: 13,           // 文字的字体大小,默认 15。
            formatter: function (value) {
              if (data.warning) {
                return '{c|' + value_show + '}' + '\n' + '{b|' + title + '}'
              } else {
                return '{a|' + value_show + '}' + '\n' + '{b|' + title + '}'
              }
              // return '{a|' + value / multiple + '}' + '\n' + '{b|' + title + '}'
            },
            rich: {
              a: {
                color: '#fff',
                fontSize: 12,
                lineHeight: 12,
                fontFamily: "BTZ",
              },
              c: {
                color: '#FF3F3F',
                fontSize: 12,
                lineHeight: 12,
                fontFamily: "BTZ",
              },
              b: {
                color: 'rgba(255, 255, 255, 0.65)',
                fontSize: 12,
              },
            },
          },
        }
      ]
    };
    this.setState({ option })
  }

  rgbToHex = (r, g, b) => {
    var hex = ((r << 16) | (g << 8) | b).toString(16);
    return "#" + new Array(Math.abs(hex.length - 7)).join("0") + hex;
  }

  // hex to rgb
  hexToRgb = (hex) => {
    var rgb = [];
    for (var i = 1; i < 7; i += 2) {
      rgb.push(parseInt("0x" + hex.slice(i, i + 2)));
    }
    return rgb;
  }

  // 计算渐变过渡色
  gradient = (startColor, endColor, step) => {
    // 将 hex 转换为rgb
    let sColor = this.hexToRgb(startColor),
      eColor = this.hexToRgb(endColor);

    // 计算R\G\B每一步的差值
    let rStep = (eColor[0] - sColor[0]) / step;
    let gStep = (eColor[1] - sColor[1]) / step;
    let bStep = (eColor[2] - sColor[2]) / step;

    var gradientColorArr = [];
    for (var i = 0; i < step; i++) {
      // 计算每一步的hex值
      gradientColorArr.push(this.rgbToHex(parseInt(rStep * i + sColor[0] + ''), parseInt(gStep * i + sColor[1] + ''), parseInt(bStep * i + sColor[2] + '')));
    }
    return gradientColorArr;
  }

  allGradient = (dur, type) => { // 0--四段 1---三段
    const color = colors[type];
    let arr = [];
    let returnArr = [];
    for (let i = 0; i < color.length - 1; i++) {
      var step = (dur[i + 1] - dur[i])
      var colorArr = this.gradient(color[i], color[i + 1], step);

      if (type == 1 && i == color.length - 2) { // 三段--最后一段，不计算渐变颜色
        for (var j = 0; j < step; j++) {
          arr.push(color[i + 1]);
        }
      } else if (type == 0 && i == 0) { //五段--第一段，最后一段，不计算渐变颜色
        for (var j = 0; j < step; j++) {
          arr.push(color[i]);
        }
      } else if (type == 0 && i == color.length - 2) { //五段--第一段，最后一段，不计算渐变颜色
        for (var j = 0; j < step; j++) {
          arr.push(color[i + 1]);
        }
      } else {
        arr.push(...colorArr);
      }
    }
    let len = arr.length;
    arr.map(function (item, index) {
      var a = [(index + 1) / len, item];
      returnArr.push(a)
    })
    return returnArr
  }
  //为原值的100倍,如果是正无穷，则指定最大值为当前最大值的两倍
  arrayDeal = (data) => {
    const { multiple } = this.state;
    let _data = [];
    data.map((item, index) => {
      if (item == '+∞') {
        _data[data.length - 1] = (data[data.length - 2] * 2) * multiple;
      } else {
        _data.push(item * multiple);
      }

    })
    return _data;
  }
  formatData = (data) => {
    const _data = this.arrayDeal(data);
    // console.log('arrayDeal-------', _data)
    // let dur = [_data[0]];
    // for (let i = 0; i < _data.length - 3; i++) {
    //   dur.push((_data[i + 2] - _data[i + 1]) / 2 + _data[i + 1])
    // }
    // dur.push(_data[_data.length - 1]);
    // console.log('dur-------', dur)
    return _data
  }
  render() {
    const { option } = this.state;
    const { loading, width } = this.props;
    return (
      <div style={{ width: width }}>
        <CommonlyChart loading={loading} option={option} height={'100px'} />
      </div>
    )
  }
}

export default Gauge
